module.exports = __webpack_public_path__ + "img/wordpress.2d515662.svg";